import { clearPagesCache } from './react';
import { Router } from './react/router';
import { createPage } from './share';
import { removeStartSlash, loadBuiltFile, splitRoutes } from './utils';

declare let MAX_ROUTES: Record<string, string>;
declare const maxDsl: any;

export const router = Router();
export const loadResource = loadBuiltFile;
export const getAllRoutes = splitRoutes;

export const create = createPage(router.maxRouterHistory.maxPageRender);
export { SubPage } from './share';

export const start = () => {
  loadBuiltFile('dist/routes.mjs').then(async () => {
    const defaultRoute = MAX_ROUTES['$default'];

    const url = removeStartSlash(location.href.substring(location.origin.length));
    if (url) {
      router.navigateTo(url);
    } else {
      window.location.replace(`/${defaultRoute}${location.search}`);
    }
  });

  maxDsl.rootMax.onClearSubPageCache((route: string) => {
    clearPagesCache(route);
  });
};
